export default {"src":"/_next/static/media/healthins.50076303.svg","height":89,"width":89,"blurWidth":0,"blurHeight":0};